import * as GAME from 'vibegame';

export const TextGeneration = GAME.defineComponent({
  t: GAME.Types.f32,
  pulsePhase: GAME.Types.f32,
});

const textGenerationQuery = GAME.defineQuery([TextGeneration]);

const TextGenerationPulseSystem: GAME.System = {
  group: 'simulation',
  update(state) {
    for (const eid of textGenerationQuery(state.world)) {
      if (TextGeneration.t[eid] > 0) {
        TextGeneration.pulsePhase[eid] += state.time.deltaTime * 3;
      }
    }
  },
};

export const IntroPlugin: GAME.Plugin = {
  components: { TextGeneration },
  systems: [TextGenerationPulseSystem],
  config: {
    defaults: {
      'text-generation': { t: 0, pulsePhase: 0 },
    },
  },
};
